import { css } from '@emotion/core';
import { truncateLines, designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
export var address = /*#__PURE__*/css(designTokenFonts.body);
export var scope = {
  name: "tj0ab2",
  styles: "padding-right:6px;"
};
export var line1 = /*#__PURE__*/css(truncateLines(1));